document.addEventListener("DOMContentLoaded", () => {

    async function addItems(items) {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                items: items
            })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.description || data.message || "Add to cart failed");
        }

        return data;
    }

    const buttons = document.querySelectorAll(".um-add-cart-btn");

    buttons.forEach(btn => {
        btn.addEventListener("click", async function () {
            const variantId = Number(this.dataset.variantId);

            this.disabled = true;
            this.innerText = "Adding...";

            try {
                const items = [{
                    id: variantId,
                    quantity: 1
                }];

                console.log("Adding Items:", items);

                const result = await addItems(items);
                console.log("Add Success:", result);

                if (window.umDrawer) {
                    if (typeof window.umDrawer.refresh === "function") {
                        await window.umDrawer.refresh();
                    }

                    if (typeof window.umDrawer.open === "function") {
                        setTimeout(() => {
                            window.umDrawer.open();
                        }, 100);
                    }
                }

                this.innerText = "Added ✓";

            } catch (err) {
                console.error("Add to cart failed:", err);
                alert(err.message);
                this.innerText = "Error";
            }

            setTimeout(() => {
                this.disabled = false;
                this.innerText = "Add To Cart";
            }, 1500);
        });
    });

});